'use client';

import { proxyFetch } from '@ps/functions/utils/proxyFetch';

import type { PreviewCoupon } from './applyCouponsToUnitPrice';

/**
 * Fetch a coupon by code for a listing — **display-only preview**, no
 * redemption. Mirrors PopshopRN's `useCouponPreview` /
 * `couponApiControllerGetListingCouponByCode`: a public GET that returns the
 * coupon's discount shape so the PDP can show a strikethrough discounted price
 * before the shopper commits. The real redeem happens later, in checkout.
 *
 * Goes through the `/api/bio/coupon-preview` proxy so the generated `CouponApi`
 * client stays off the visitor bundle. Returns `null` when there's no
 * matching/enabled coupon (or on any error) so the caller silently falls back
 * to the normal price.
 */
export async function fetchCouponPreview(args: {
  sellerId: string;
  listingId: string;
  code: string;
}): Promise<PreviewCoupon | null> {
  try {
    const params = new URLSearchParams({
      sellerId: args.sellerId,
      listingId: args.listingId,
      code: args.code,
    });
    return await proxyFetch<PreviewCoupon | null>(
      `/api/bio/coupon-preview?${params.toString()}`,
    );
  } catch {
    return null;
  }
}
